import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Permanent venue TV URL (/:venueCode/tv). Resolves the venue's saved
 * TV Display Theme and hands off to the matching self-contained vanilla
 * renderer under /tv/*.html — keeping the TV page framework-free and light
 * for cheap Android TVs (per the approved prototypes). The static page polls
 * the feed and auto-switches themes if the venue changes it.
 */
export default function TVThemeRedirect() {
  const { venueCode } = useParams();
  useEffect(() => {
    const code = (venueCode || '').toUpperCase();
    if (!code) return;
    let done = false;
    const go = (theme, palette, accent) => {
      if (done) return;
      done = true;
      const params = new URLSearchParams(window.location.search);
      const t = theme === 'premium' ? 'premium' : 'quirky';
      let url = `/tv/${t}.html?venue=${encodeURIComponent(code)}&demo=0`;
      if (BACKEND) url += `&api=${encodeURIComponent(BACKEND)}`;
      if (palette) url += `&palette=${encodeURIComponent(palette)}`;
      if (accent) url += `&accent=${encodeURIComponent(accent)}`;
      // preserve TV debug/lite overrides if present on the original URL
      ['lite', 'full', 'debug'].forEach((k) => {
        if (params.get(k)) url += `&${k}=${encodeURIComponent(params.get(k))}`;
      });
      window.location.replace(url);
    };
    fetch(`${API}/venue/${code}/tv-feed`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => go(d ? d.tv_theme : 'quirky', d ? d.tv_palette : '', d ? d.tv_accent : ''))
      .catch(() => go('quirky', '', ''));
  }, [venueCode]);

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', fontFamily: 'sans-serif' }}
      data-testid="tv-theme-redirect"
    >
      Loading display…
    </div>
  );
}
